import { Typography } from '@/components/atoms/Typography';
import { FileTextIcon } from '@/components/atoms/icons/FileTextIcon';
import { SignatureIcon } from '@/components/atoms/icons/SignatureIcon';
import { useUIColors } from '@/core/hooks';
import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';

export interface QuickLinksSectionProps {
    onAccountStatement?: () => void;
    onCollectCheques?: () => void;
}

export const QuickLinksSection = React.memo<QuickLinksSectionProps>(function QuickLinksSection({
    onAccountStatement,
    onCollectCheques,
}) {
    const colors = useUIColors();

    return (
        <View style={styles.container}>
            <Typography variant="subhead" color="primary" style={styles.title}>
                Quick links
            </Typography>
            <View style={styles.buttonsContainer}>
                <Pressable
                    style={[styles.button, { borderColor: colors.buttonDefault }]}
                    onPress={onAccountStatement}
                >
                    <View style={styles.iconContainer}>
                        <FileTextIcon size={20} color={colors.fontPrimary} />
                    </View>
                    <Typography
                        variant="subhead"
                        color="primary"
                        style={styles.buttonTitle}
                        numberOfLines={2}
                        ellipsizeMode="tail"
                    >
                        Account statement
                    </Typography>
                </Pressable>

                <Pressable
                    style={[styles.button, { borderColor: colors.buttonDefault }]}
                    onPress={onCollectCheques}
                >
                    <View style={styles.iconContainer}>
                        <SignatureIcon size={20} color={colors.fontPrimary} />
                    </View>
                    <Typography
                        variant="subhead"
                        color="primary"
                        style={styles.buttonTitle}
                        numberOfLines={2}
                        ellipsizeMode="tail"
                    >
                        Shred cheques
                    </Typography>
                </Pressable>
            </View>
        </View>
    );
});

const styles = StyleSheet.create({
    container: {
        gap: 8,
    },
    title: {
        marginBottom: 0,
    },
    buttonsContainer: {
        flexDirection: 'row',
        gap: 12,
    },
    button: {
        flex: 1,
        borderWidth: 1,
        borderRadius: 6,
        flexDirection: 'row',
        alignItems: 'center', // Back to center for proper alignment
        paddingHorizontal: 8,
        paddingVertical: 12,
        gap: 8,
        minHeight: 48, // Ensure minimum height for consistent button sizes
    },
    buttonText: {
        flex: 1,
        alignItems: 'center',
    },
    iconContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        height: 20, // Match icon height for proper centering
    },
    buttonTitle: {
        marginBottom: 0,
        flex: 1, // Allow text to take available space
        textAlign: 'left', // Ensure left alignment for readability
    },
    buttonSubtitle: {
        marginBottom: 0,
    },
});

export default QuickLinksSection;
